import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosHeaders } from 'axios'
import { getMergedHeaders, StringMap } from './utils'
import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'

// This is to set in apps - env and register it via vite config
// Ref: https://vite.dev/config/shared-options#envprefix
const apiURL = process.env.GLOBAL_REAPIT_SALES_API_V2_URL

interface ClientIDRef {
  current: string
}

const clientIDRef: ClientIDRef = {
  current: '',
}

export function setClientID(clientID: string) {
  clientIDRef.current = clientID
}

export const apiClient: AxiosInstance = axios.create({
  baseURL: apiURL,
  params: {
    version: '2',
  },
})

// Request interceptor
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    config.headers.set('X-Client-ID', clientIDRef.current)
    const mergedHeaders: StringMap | null = await getMergedHeaders(reapitConnectBrowserSession, config.headers)
    if (mergedHeaders) {
      config.headers = new AxiosHeaders(mergedHeaders)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    // To do: handle response errors
    return Promise.reject(error)
  },
)
